import { render, staticRenderFns } from "./CreateUpdateMsKeg.vue?vue&type=template&id=2fa5f2b5&scoped=true"
import script from "./CreateUpdateMsKeg.vue?vue&type=script&lang=js"
export * from "./CreateUpdateMsKeg.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateMsKeg.vue?vue&type=style&index=0&id=2fa5f2b5&prod&scoped=true&lang=scss"
import style1 from "./CreateUpdateMsKeg.vue?vue&type=style&index=1&id=2fa5f2b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5f2b5",
  null
  
)

export default component.exports